import React from 'react'
import { useAlert } from '../../../../context/AlertContext'
import clinicTeamServices from '../../../clinic/clinicTeamServices';
import { Delete } from '@mui/icons-material';



function ReceivedPendingRequestList({receivedPendingRequest, callBack}) {
    
    const {AppAlert} = useAlert();

    const updateRequestStatus = (clinicId,request,requestStatus) =>{
        let payload = {
            clinicId:clinicId,
            associateId: request.associateId,
            requestId:request.requestId,
            requestStatus:requestStatus,
        }
        clinicTeamServices.updateRequestStatus(payload).then(res=>{
            console.log(res.data);
            AppAlert("Request Status Updated");
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error")
        })
    }

    return (
        <>
            {receivedPendingRequest?.map(clinic=>
                <div key={clinic.clinicId} className='card mb-2'>
                    <div className='card-header bg-info'>Join request for <span className='fw-bold'>{clinic.title}</span></div>
                    <div className=''>
                        <table className='table table-striped mb-0'>
                            <tbody>
                                {clinic.requestList.map(request=>
                                    <tr key={request.requestId}>
                                        <td><span className='fw-bold'>Name : </span>{request.firstName} </td>
                                        <td><span className='fw-bold'>Phone : </span>{request.phone}</td>
                                        <td>{ clinicTeamServices.requestStatusLabel[request.requestStatus]}</td>
                                        <td>
                                            { (request.requestStatus == 0 || request.requestStatus == 2 || request.requestStatus == 3) &&
                                                <>
                                                    <button className='m-1 btn btn-success rounded-pill'
                                                        onClick={()=>{
                                                            updateRequestStatus(clinic.clinicId,request, 1)
                                                        }}    
                                                    >Accept</button>
                                                    <button className='m-1 btn btn-danger  rounded-pill'
                                                        onClick={()=>{
                                                            updateRequestStatus(clinic.clinicId,request, 2)
                                                        }}    
                                                    >Ignore</button>
                                                    <button className='m-1 btn btn-warning rounded-pill'
                                                        onClick={()=>{
                                                            updateRequestStatus(clinic.clinicId,request, 3)
                                                        }}    
                                                    >Reject</button>
                                                </>
                                            }

                                            { (request.requestStatus == 1) &&
                                                <button className='mx-1 btn btn-outline-danger rounded-pill'
                                                        onClick={()=>{
                                                            updateRequestStatus(clinic.clinicId,request, 0)
                                                        }}    
                                                    ><Delete/> Remove From Team</button>
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    )
}

export default ReceivedPendingRequestList